import React, { ReactNode } from 'react'
import { Message, TypingIndicator } from '@chatscope/chat-ui-kit-react'
import { MarkdownMessage } from 'components'
import { Avatar as ChatAvatar } from '@chatscope/chat-ui-kit-react'

interface ChatMessageProps {
  note?: string
  question: string | ReactNode
  body?: string | ReactNode
  blobAvatarUrl?: string
  isTyping: boolean
}

const DefaultFlowMessage: React.FC<ChatMessageProps> = ({
  note = '',
  question = '',
  body = '',
  blobAvatarUrl,
  isTyping
}) => {
  const payload = (
    <Message.CustomContent className="text-base min-h-[50px] py-3 vsmall:py-1.5">
      <MarkdownMessage key="note" content={note} />

      {isTyping ? (
        <TypingIndicator className="min-h-[25px] !relative !bg-transparent transition-opacity duration-500 ease-in-out text-text-base" />
      ) : (
        <>
          <div className="mt-2 vsmall:mt-1 transition-opacity duration-300 ease-in-out opacity-100">{question}</div>
          {!!body && <>{body}</>}
        </>
      )}
    </Message.CustomContent>
  )

  return (
    <>
      {/* Mobile */}
      <div className="flex flex-col items-start big-avatar gap-2 lg:hidden">
        {blobAvatarUrl && <ChatAvatar src={blobAvatarUrl} className="bg-white avatar-head-only" />}
        <Message model={{ direction: 'incoming', type: 'custom', position: 'single', payload }} />
      </div>

      {/* Desktop */}
      <div className="hidden big-avatar lg:block">
        <Message
          model={{ direction: 'incoming', type: 'custom', position: 'single', payload }}
          avatarPosition="tl"
          {...(blobAvatarUrl && {
            children: <ChatAvatar src={blobAvatarUrl} className="bg-white avatar-head-only" />
          })}
        />
      </div>
    </>
  )
}

export default DefaultFlowMessage
